module.exports = __webpack_public_path__ + "0bdf251951d8db7d44f9448022650233.png";